<template>
  <div v-loading="loading">
    <search-base
      ref="SearchBase"
      :data="formData"
      @search="onSearch"
    ></search-base>
  </div>
</template>

<script>
import SearchBase from './components/Base.vue';
import { getBoard } from '@/api/search/position/gain.js';

export default {
  data() {
    return {
      loading: false,
      query: {},
      formData: {}
    };
  },
  components: {
    SearchBase
  },
  methods: {
    onSearch(queryParams) {
      Object.assign(queryParams, this.query);
      this.$emit('search', queryParams);
    },
    getData() {
      this.loading = true;
      getBoard(this.query)
        .then(res => {
          this.formData = res;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style></style>
